import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalModule } from 'src/app/global/global.module';
import { ComponentsModule } from 'src/app/global/components/components.module';
import { AcompanhamentoVendaMainComponent } from './acompanhamento-venda-main/acompanhamento-venda-main.component';

@NgModule({
  declarations: [AcompanhamentoVendaMainComponent],
  imports: [CommonModule, GlobalModule, ComponentsModule],
})
export class AcompanhamentoVendaModule { }
